export default __webpack_public_path__ + "static/media/oracle.efe48393.svg";